import * as React from 'react'

import { Icon } from '~/components/icon/Icon'
import { cn } from '~/styled'

export const TreeIcon = ({
  className,
  ...props
}: React.ComponentProps<typeof Icon>): React.JSX.Element => (
  <Icon
    size="md"
    {...props}
    className={cn('my-1', 'shrink-0', 'self-start', className)}
  />
)
